var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tab',{attrs:{"header":"How can you reduce your CO2 footprint?","loading":_vm.loadingTips,"tabs":_vm.tips,"company":_vm.getUserCompany()}})}
var staticRenderFns = []

export { render, staticRenderFns }